import React, { useState } from 'react'
import  "./style.css"

const Tabs = ({ List, onApply , className , activeTab }) => {


    const handleActiveTab = (id) => {   
        onApply(prev => id)
    }


    return (
        <div className={`tabs-container ${className}`}>
            {List?.map(item => (
                <div className={`tab ${activeTab == item?.value ? "active-tab"  :""}`} onClick={() => handleActiveTab(item?.value)}>{item?.label}</div>
            ))}
        </div>)
}

export default Tabs